import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { TwoColumnLayoutService } from 'src/app/common-components/column-layouts/two-column-list-layout/services/selected-id.service';
import { Register } from 'src/app/common-components/register/models/register';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getDepartmentPrivileges } from 'src/app/privileges/privileges.selector';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import {
   deactivateDepartment,
   deleteDepartment,
   mergeDepartment,
   renameDepartment,
   untagDepartment,
} from '../../department-details/state/department-detail.actions';
import { DepartmentsFilterOption } from '../models/department-filter-option';
import { DepartmentPrivileges } from '../models/department-privileges';
import { DepartmentOrderingOptions, DepartmentRegisterOptions } from '../models/department-register-options';
import { DepartmentRegisterListItem } from '../models/department-register-results.model';
import * as DepartmentRegisterActions from '../state/department-register.actions';
import {
   createDepartment,
   departmentRegisterAdapterActions,
   departmentRegisterInitialFilter,
} from '../state/department-register.actions';
import * as departmentRegisterReducer from '../state/department-register.reducer';
@Component({
    selector: 'ndt-department-register',
    templateUrl: './department-register.component.html',
    standalone: false
})
export class DepartmentRegisterComponent
   extends Register<DepartmentRegisterListItem, DepartmentRegisterOptions, DepartmentOrderingOptions>
   implements OnInit
{
   columns: string[] = ['name', 'description'];

   entityName = 'Department';

   departmentPrivileges$: Observable<DepartmentPrivileges>;

   filters: DepartmentsFilterOption[];

   @Output() quickFilterChange: EventEmitter<DepartmentRegisterOptions> = new EventEmitter<DepartmentRegisterOptions>();

   registerOptions: DepartmentRegisterOptions;

   constructor(public store: Store, private twoColumnLayoutService: TwoColumnLayoutService) {
      super(store, departmentRegisterReducer.selectors, departmentRegisterAdapterActions);
      this.departmentPrivileges$ = store.pipe(select(getDepartmentPrivileges));

      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: DepartmentsFilterOption[] = [
                  {
                     field: 'AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
                  {
                     field: 'IsActive',
                     operation: FilterOperations.EqualTo,
                     type: 'boolean',
                     value: true,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
            this.twoColumnLayoutService.setSelectedId(null);
         });
   }

   ngOnInit() {
      this.store.dispatch(departmentRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
      this.twoColumnLayoutService.changesToNotify$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
         this.store.dispatch(DepartmentRegisterActions.refreshList());
      });
   }

   onCreate(): void {
      this.store.dispatch(createDepartment());
   }

   handleSelectedId(id: number) {
      this.twoColumnLayoutService.setSelectedId(id);
   }

   onShowAllDepartmentsChange(showAllDepartmentsSelected: boolean): void {
      this.registerOptions = { ...this.registerOptions, showAllDepartments: showAllDepartmentsSelected };
      this.quickFilterChange.emit(this.registerOptions);
   }

   onDepartmentRename(department: DepartmentRegisterListItem) {
      this.store.dispatch(renameDepartment({ departmentId: department.departmentId, name: department.name }));
   }

   onDepartmentDeactivate(department: DepartmentRegisterListItem) {
      this.store.dispatch(deactivateDepartment({ department: department }));
   }
   onDepartmentMerge(department: DepartmentRegisterListItem) {
      this.store.dispatch(
         mergeDepartment({
            departmentId: department.departmentId,
            name: department.name,
            accountId: department.accountId,
         })
      );
   }
   onDepartmentUntag(department: DepartmentRegisterListItem) {
      this.store.dispatch(untagDepartment({ departmentId: department.departmentId, name: department.name }));
   }

   onDepartmentDelete(department: DepartmentRegisterListItem) {
      this.store.dispatch(deleteDepartment({ departmentId: department.departmentId, name: department.name }));
   }
}
